"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = makeMaterialStyle;
function makeMaterialStyle(theme) {
  return {
    menu: {
      "& $listItem": {
        color: theme.vars.palette.text.primary
      },
      "& $listItemIcon": {
        color: theme.vars.palette.text.primary
      }
    },
    listItem: {},
    listItemIcon: {}
  };
}